import { useEffect, useId, useRef, type ReactNode } from "react";
import estilos from "./Dialogo.module.css";

/**
 * Diálogo modal sobre el elemento `<dialog>` nativo: el navegador atrapa el foco, cierra con Escape y
 * devuelve el foco a quien lo abrió. No se cierra al hacer clic fuera, para no perder lo escrito.
 */
export function Dialogo({
  abierto,
  titulo,
  descripcion,
  alCerrar,
  children,
}: {
  readonly abierto: boolean;
  readonly titulo: string;
  readonly descripcion?: ReactNode;
  readonly alCerrar: () => void;
  readonly children: ReactNode;
}) {
  const ref = useRef<HTMLDialogElement>(null);
  const idTitulo = useId();
  const idDescripcion = useId();

  useEffect(() => {
    const d = ref.current;
    if (!d) return;
    if (abierto && !d.open) d.showModal();
    if (!abierto && d.open) d.close();
  }, [abierto]);

  return (
    <dialog
      ref={ref}
      className={estilos.dialogo}
      aria-labelledby={idTitulo}
      aria-describedby={descripcion ? idDescripcion : undefined}
      onClose={alCerrar}
    >
      {abierto && (
        <>
          <h2 id={idTitulo} className={estilos.titulo}>
            {titulo}
          </h2>
          {descripcion && (
            <div id={idDescripcion} className={estilos.descripcion}>
              {descripcion}
            </div>
          )}
          {children}
        </>
      )}
    </dialog>
  );
}
